import { useMutation } from '@tanstack/react-query';
import { Questionnaire } from '../../../../types';
import * as questionnairesApi from '../../../../../../apis/questionnaires/requests';
import { useHistory } from 'react-router';
import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';

export const useDeleteQuestionnaire = (questionnaire: Questionnaire) => {
  const history = useHistory();

  const { isSuccess, mutate: deleteQuestionnaire } = useMutation(() => {
    if (questionnaire._id) {
      return questionnairesApi.deleteQuestionnaire(String(questionnaire._id));
    }

    return Promise.resolve();
  });

  const deleteQuestionnaireWithWarningOrGoBack = () => {
    if (!questionnaire._id) {
      return history.goBack();
    }

    const shouldDelete = window.confirm(`Are you sure you want to delete ${questionnaire.title} questionnaire?`);

    if (shouldDelete) {
      deleteQuestionnaire();
    }
  };

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Questionnaire deleted!', { variant: 'success' });
      history.push('/questionnaires');
    }
  }, [isSuccess, history]);

  return deleteQuestionnaireWithWarningOrGoBack;
};
